<app-header></app-header>
<div class="container-fluid bg-light px-lg-5">
  <nav *ngIf="resource" class="navbar navbar-expand-lg navbar-light">
    <!-- <a class="navbar-brand" href="#"></a> -->
    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav"
            aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarNav">
      <ul class="navbar-nav">
        <li class="nav-item" routerLinkActive="active">
          <a class="nav-link paddingFromApp" routerLink="/landing">
            Home <span class="sr-only">(current)</span>
          </a>
        </li>
        <li class="nav-item" routerLinkActive="active">
          <a class="nav-link" routerLink="/started">Getting Started</a>
        </li>
        <li class="nav-item" routerLinkActive="active">
          <a class="nav-link" routerLink="/resources">Resources</a>
        </li>
      </ul>
    </div>
  </nav>
</div>
<div class="container-fluid bg-light px-lg-5">
  <nav *ngIf="postResource" class="navbar navbar-expand-lg navbar-light">
    <!-- <a class="navbar-brand" href="#"></a> -->
    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav"
            aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarNav">
      <ul class="navbar-nav">
        <li class="nav-item" routerLinkActive="active">
          <a class="nav-link paddingFromApp" routerLink="/registration">
            App Registration <span class="sr-only">(current)</span>
          </a>
        </li>
        <li class="nav-item" routerLinkActive="active">
          <a class="nav-link" routerLink="/app-mgmt">App Management</a>
        </li>
        <li class="nav-item" routerLinkActive="active">
          <a class="nav-link" routerLink="/profile-mgmt">Profile Management</a>
        </li>
        <li class="nav-item" routerLinkActive="active">
          <a class="nav-link" routerLink="/resources">Resources</a>
        </li>
      </ul>
    </div>
  </nav>
</div>
<br>
<br>
<div class="container" style="font-family: 'BentonSans'; margin-left: 50px;">
  <h1 style="color:#007bff;">Resource</h1>
  <p><br></p>
  <p>There are list of Patient Access API URL for getting different resource type. To access these API, we need &nbsp;to Authenticate by passing the Bearer Token in request header. To Generate the token, need steps as below:</p>
  <p>1.<span style="white-space:pre;">&nbsp; &nbsp;&nbsp;</span>Register the app in developer portal and keep handy client id and client secret from there to use in create token.</p>
  <p>2.<span style="white-space:pre;">&nbsp; &nbsp;&nbsp;</span>Need to hit the Token endpoint URL with the following details,&nbsp;</p>
  <p><br></p>
  <p><b>Authorization Token & Refresh Token Generation:</b></p>
  <p><b>Metadata</b></p>
  <p>The metadata endpoint provides access to the FHIR Capability Statement of the server.</p>
  <p>Endpoint:GET https://baseurl/metadata</p>
  <p><b>Steps To Generate Authorization Token.</b></p>
  <p>1.<span style="white-space:pre;">&nbsp; &nbsp;&nbsp;</span>The third-party application developer refers to the metadata URL to configure & access the Patient Access APIs. metadata listed the OAuth, resource endpoints & other required URL details.</p>
  <p>2.<span style="white-space:pre;">&nbsp; &nbsp;&nbsp;</span>The developer will integrate the OAuth URL with the required query parameters which are listed below.</p>
  <p>OAuth URL:</p>
  <p>https://b2cbcbsricmsprod.b2clogin.com/b2cbcbsricmsprod.onmicrosoft.com/oauth2/v2.0/authorize?p=B2C_1A_MemberPortal_signup_signin</p>
  <p><br></p>
  <p><b>Query parameters</b></p>
  <p>a.<span style="white-space:pre;">&nbsp; &nbsp;&nbsp;</span> Client_id: Registered Application Id</p>
  <p>Example&nbsp; :&nbsp; xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx</p>
  <p>b.<span style="white-space:pre;">&nbsp; &nbsp;&nbsp;</span>redirect_uri: Third Party Application Redirect URI</p>
  <p>Example&nbsp;:&nbsp; https//:jwt.ms</p>
  <p>c.<span style="white-space:pre;">&nbsp; &nbsp;&nbsp;</span> scope: OpenID: is an authentication protocol built on OAuth 2.0 that you can use to securely sign in a user to an application</p>
  <p>Example:OpenID</p>
  <p>d.<span style="white-space:pre;">&nbsp; &nbsp;&nbsp;</span>response_type:</p>
  <p>code: use to get the refresh token from redirect URI.</p>
  <p>Id_token: use to get the access token from redirect URL.</p>
  <p>Example: code + id_token</p>
  <p>e.<span style="white-space:pre;">&nbsp; &nbsp;&nbsp;</span>Prompt: login</p>
  <p>Login page</p>
  <p><br></p>
  <p><b>Integrated Authorization URL Example:</b> </p>
  <p>https://b2cbcbsricmsprod.b2clogin.com/b2cbcbsricmsprod.onmicrosoft.com/oauth2/v2.0/authorize?p=B2C_1A_MemberPortal_signup_signin&client_id=xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx &nonce=defaultNonce&redirect_uri=third-party-redirect-uri-value&scope=openid&response_type=code+id_token&prompt=login</p>
  <p>3.<span style="white-space:pre;">&nbsp; &nbsp;&nbsp;</span>Developer uses the integrated Authorization URL, where it Navigate to the login page to provide user credentials.</p>
  <p>4.<span style="white-space:pre;">&nbsp; &nbsp;&nbsp;</span>Authentication URL redirects to Member Portal login.</p>
  <p>5.<span style="white-space:pre;">&nbsp; &nbsp;&nbsp;</span>On the Successful Authentication, the Consent page will be prompted to the user and can consent to one or multiple members (If dependent is added).</p>
  <p>6.<span style="white-space:pre;">&nbsp; &nbsp;&nbsp;</span>The Access Token will be generated in a Redirect URI.</p>
  <p>7.<span style="white-space:pre;">&nbsp; &nbsp;&nbsp;</span>With the generated token the user can able to access the Patient Access APIs from Third Party Application.</p>
  <p><br></p>
  <p><b>Steps To Generate Refresh Token.</b></p>
  <p>1.<span style="white-space:pre;">&nbsp; &nbsp;&nbsp;</span>After successful login It will  get the id_access & code in a redirect URL, below query string-</p>
  <p>Id_access: Access Token</p>
  <p>Code: Authorization code which will be used to retrieve refresh token</p>
  <p>Example: https://jwt.ms/code=code-value&id_token=token-value</p>
  <p>2.<span style="white-space:pre;">&nbsp; &nbsp;&nbsp;</span>Get a refresh token using below POST query through the postman</p>
  <p><b>Token URL:</b> </p>
  <p>https://b2cbcbsricmsprod.b2clogin.com/b2cbcbsricmsprod.onmicrosoft.com/oauth2/v2.0/token?p=b2c_1a_memberportal_signup_signin</p>
  <p>Post Header:</p>
  <p>Content-Type: application/x-www-form-urlencoded</p>
  <p><b>Post Body:</b></p>
  <p>grant_type=authorization_code</p>
  <p>client_id=xxxxxxxxxxx</p>
  <p>scope=xxxxxxxxxxx offline_access openID</p>
  <p>code=AuthorizationCode-Value</p>
  <p>redirect_uri=redirect URL</p>
  <p><br></p>
  <p><b>Response Body:</b></p>
  <p>"access_token": "token-value",</p>
  <p>"id_token": "token-value",</p>
  <p>"token_type": "Bearer",</p>
  <p>"not_before": xxxxxxx,</p>
  <p>"expires_in": 3600,</p>
  <p>"expires_on": yyyyyyy,</p>
  <p>"resource":"zzzzzzz",</p>
  <p>"id_token_expires_in": 3600,</p>
  <p>"profile_info": "token",</p>
  <p>"scope": "/ openid offline_access",</p>
  <p>"refresh_token": "token-value",</p>
  <p>"refresh_token_expires_in": yyyyyyy</p>
  <p><br></p>
  <p>3.<span style="white-space:pre;">&nbsp; &nbsp;&nbsp;</span>	Get Access Token using Refresh token</p>
  <p><b>Token URL:</b></p>
  <p>https://b2cbcbsricmsprod.b2clogin.com/b2cbcbsricmsprod.onmicrosoft.com/oauth2/v2.0/token?p=b2c_1a_memberportal_signup_signin</p>
  <p>Post Header:</p>
  <p>Content-Type: application/x-www-form-urlencoded</p>
  <p><b>POST Body:</b></p>
  <p>grant_type=refresh_token</p>
  <p>client_id=xxxxxxxxxxx offline_access</p>
  <p>scope=xxxxxxxxxxx openid offline_access</p>
  <p>refresh_token=refresh-token-value</p>
  <p>redirect_uri=Redirect URL</p>
  <p><br></p>
  <p><b>Response Body:</b></p>
  <p>"access_token": "token-value",</p>
  <p>"id_token": "token-value",</p>
  <p>"token_type": "Bearer",</p>
  <p>"not_before": xxxxxxx,</p>
  <p>"expires_in": 3600,</p>
  <p>"expires_on": xxxxxxx,</p>
  <p>"resource": "xxxxxxxxxxx ",</p>
  <p>"id_token_expires_in": 3600,</p>
  <p>"profile_info": "token-value",</p>
  <p>"scope": "/ openid"</p>
  <p>4.<span style="white-space:pre;">&nbsp; &nbsp;&nbsp;</span>	With the generated access-token the user can able to access the API’s.</p>
  <p><br></p>
  <p><b>Patient Access API</b></p>
  <p><a class="pl-4" (click)="OnLogoClick()">Detail&nbsp;link</a></p>
  <p><br></p>
  <p><b>Support</b></p>
  <p><a class="pl-4" (click)="OnLogoClick()">Detail&nbsp;link</a></p>
  <p><br></p>
</div>
<div>
  <app-footer></app-footer>
</div>
